import withMediaControl from 'EditorWidgets/withMedia/withMediaControl';

const FileControl = withMediaControl();

export default FileControl;



// WEBPACK FOOTER //
// ./components/EditorWidgets/File/FileControl.js